export enum EsignStateEnum {
    None = 'None',
    Requested = 'Requested',
    Signed = 'Signed',
    Rejected = 'Rejected'
}

export type EsignUpdateIntent = 'Create' | 'Reuse' | 'ReuseOrCreate';
